<template>
  <div>
    <v-row class="py-0">
      <v-col cols="6">
        <h3 class="title dw_green--text font-weight-light">
          <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiCrownOutline" />
          Create a New Play
          <v-btn
            small
            icon
            class="ml-2"
            @click="simpleSideList = 'playList'; $vuetify.goTo('#simpleSideList')">
            <v-icon color="dw_green" v-text="mdiMenuRight" />
          </v-btn>
        </h3>
        <v-form ref="addPlayForm" v-model="formValid" @submit.prevent>
          <v-card flat color="bg_dark">
            <v-card-text class="px-4 py-0" style="min-height: 35vh;">
              <v-text-field
                v-model="newPlay"
                :counter="256"
                label="Name of Suggested Play *"
                color="dw_green"
                :rules="[vRules.required, vRules.min, vRules.max, vRules.textRegex]"
              ></v-text-field>
              <v-textarea
                v-model="newPlayDesc"
                label="Play Description *"
                counter
                maxlength="512"
                color="dw_green"
                :rules="[vRules.required, vRules.min, vRules.descMax]"
              ></v-textarea>
              <v-divider class="my-3"></v-divider>

              <v-row no-gutters class="d-block">
                <h1 class="dw_green--text font-weight-light text-h6 mb-3">
                  <v-icon color="dw_green" class="mr-2 mb-2" v-text="mdiLinkVariantPlus" />
                  CAPEC&trade; Attack Patterns
                  <v-btn
                    small
                    icon
                    class="ml-2"
                    @click="simpleSideList = 'capecList'; $vuetify.goTo('#simpleSideList')">
                    <v-icon color="dw_green" v-text="mdiMenuRight" />
                  </v-btn>
                </h1>
                <v-autocomplete
                  v-model="playCAPECs"
                  :items="capecOptions"
                  hide-selected
                  item-text="display_name"
                  item-value="id"
                  label="Play Attack Patterns"
                  placeholder="Start typing to search"
                  dense
                  return-object
                  multiple
                  clearable
                  chips
                  color="dw_green"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeCAPEC(data.item)"
                      color="dw_green"
                      outlined
                      small
                    >
                      {{ data.item.custom_id }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="(typeof data.item !== 'object')">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.display_name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-row>

              <v-row no-gutters class="d-block">
                <h1 class="dw_green--text font-weight-light text-h6 mb-3">
                  <v-icon color="dw_green" class="mr-2 mb-2" v-text="mdiLinkVariantPlus" />
                  MITRE ATT&amp;CK&reg; Techniques
                  <v-btn
                    small
                    icon
                    class="ml-2"
                    @click="simpleSideList = 'techniqueList'; $vuetify.goTo('#simpleSideList')">
                    <v-icon color="dw_green" v-text="mdiMenuRight" />
                  </v-btn>
                </h1>
                <v-autocomplete
                  v-model="playTeqs"
                  :items="techniqueOptions"
                  hide-selected
                  item-text="display_name"
                  item-value="id"
                  label="Play Techniques"
                  placeholder="Start typing to search"
                  dense
                  return-object
                  multiple
                  clearable
                  chips
                  color="dw_green"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeTechnique(data.item)"
                      color="dw_green"
                      outlined
                      small
                    >
                      {{ data.item.mitre_id }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="(typeof data.item !== 'object')">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.display_name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-row>

              <v-row no-gutters class="d-block">
                <h1 class="dw_green--text font-weight-light text-h6 mb-3">
                  <v-icon color="dw_green" class="mr-2 mb-2" v-text="mdiLinkVariantPlus" />
                  NIST SP 800-53 (Rev. 5) Controls
                  <v-btn
                    small
                    icon
                    class="ml-2"
                    @click="simpleSideList = 'controlList'; $vuetify.goTo('#simpleSideList')">
                    <v-icon color="dw_green" v-text="mdiMenuRight" />
                  </v-btn>
                </h1>
                <v-autocomplete
                  v-model="playCtrls"
                  :items="controlOptions"
                  hide-selected
                  item-text="display_name"
                  item-value="id"
                  label="Play Controls"
                  placeholder="Start typing to search"
                  dense
                  return-object
                  multiple
                  clearable
                  chips
                  color="dw_green"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeControl(data.item)"
                      color="dw_green"
                      outlined
                      small
                    >
                      {{ data.item.label }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="(typeof data.item !== 'object')">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.display_name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-row>

              <v-row no-gutters class="d-block">
                <h1 class="dw_green--text font-weight-light text-h6 mb-3">
                  <v-icon color="dw_green" class="mr-2 mb-2" v-text="mdiLinkVariantPlus" />
                  CWE&trade; Weaknesses
                  <v-btn
                    small
                    icon
                    class="ml-2"
                    @click="simpleSideList = 'cweList'; $vuetify.goTo('#simpleSideList')">
                    <v-icon color="dw_green" v-text="mdiMenuRight" />
                  </v-btn>
                </h1>
                <v-autocomplete
                  v-model="playCWEs"
                  :items="cweOptions"
                  hide-selected
                  item-text="display_name"
                  item-value="id"
                  label="Play Weaknesses"
                  placeholder="Start typing to search"
                  dense
                  return-object
                  multiple
                  clearable
                  chips
                  color="dw_green"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeCWE(data.item)"
                      color="dw_green"
                      outlined
                      small
                    >
                      {{ data.item.custom_id }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="(typeof data.item !== 'object')">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.display_name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-row>
              <v-divider class="my-3"></v-divider>

              <v-row no-gutters class="d-block">
                <h1 class="dw_green--text font-weight-light text-h6 mb-3">
                  <v-icon color="dw_green" class="mr-2 mb-2" v-text="mdiLinkVariantPlus" />
                  Pentesting Playbook Tools
                  <v-btn
                    small
                    icon
                    class="ml-2"
                    @click="simpleSideList = 'toolList'; $vuetify.goTo('#simpleSideList')">
                    <v-icon color="dw_green" v-text="mdiMenuRight" />
                  </v-btn>
                </h1>
                <v-autocomplete
                  v-model="playTools"
                  :items="toolOptions"
                  hide-selected
                  item-text="name"
                  item-value="id"
                  label="Play Tools"
                  placeholder="Start typing to search"
                  dense
                  return-object
                  multiple
                  clearable
                  chips
                  color="dw_green"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeTool(data.item)"
                      color="dw_green"
                      outlined
                      small
                    >
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="(typeof data.item !== 'object')">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-row>

              <v-row no-gutters class="d-block">
                <h1 class="dw_green--text font-weight-light text-h6 mb-3">
                  <v-icon color="dw_green" class="mr-2 mb-2" v-text="mdiLinkVariantPlus" />
                  Pentesting Playbook Tags
                  <v-btn
                    small
                    icon
                    class="ml-2"
                    @click="simpleSideList = 'tagList'; $vuetify.goTo('#simpleSideList')">
                    <v-icon color="dw_green" v-text="mdiMenuRight" />
                  </v-btn>
                </h1>
                <v-autocomplete
                  v-model="playTags"
                  :items="tagOptions"
                  hide-selected
                  item-text="name"
                  item-value="id"
                  label="Play Tags"
                  placeholder="Start typing to search"
                  dense
                  return-object
                  multiple
                  clearable
                  chips
                  color="dw_green"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeTag(data.item)"
                      color="dw_green"
                      outlined
                      small
                    >
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="(typeof data.item !== 'object')">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-row>

              <v-row no-gutters class="d-block">
                <h1 class="dw_green--text font-weight-light text-h6 mb-3">
                  <v-icon color="dw_green" class="mr-2 mb-2" v-text="mdiLinkVariantPlus" />
                  Pentesting Playbook Objectives
                  <v-btn
                    small
                    icon
                    class="ml-2"
                    @click="simpleSideList = 'objectiveList'; $vuetify.goTo('#simpleSideList')">
                    <v-icon color="dw_green" v-text="mdiMenuRight" />
                  </v-btn>
                </h1>
                <v-autocomplete
                  v-model="playObjs"
                  :items="objectiveOptions"
                  hide-selected
                  item-text="title"
                  item-value="id"
                  label="Play Objectives"
                  placeholder="Start typing to search"
                  dense
                  return-object
                  multiple
                  clearable
                  chips
                  color="dw_green"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeObjective(data.item)"
                      color="dw_green"
                      outlined
                      small
                    >
                      {{ data.item.title }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="(typeof data.item !== 'object')">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.title"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-row>
            </v-card-text>
            <v-divider class="my-3"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="button"
                @click="resetForm"
                color="dw_green"
                x-small
                text>Clear</v-btn>
              <v-btn
                type="submit"
                :disabled="!formValid"
                @click="addPlay"
                color="dw_green"
                small
                outlined>
                Add
                <v-icon small color="dw_green" class="ml-1" v-text="mdiCrown" />
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="6" id="simpleSideList">
        <component :is="simpleSideList" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mdiCrownOutline,
  mdiCrown,
  mdiMenuRight,
  mdiLinkVariantPlus,
  mdiPlus,
  mdiMinus,
  mdiMagnify
} from '@mdi/js';
import { mapActions, mapGetters } from 'vuex';
import playList from '@/components/forms/simpleLists/playList.vue';
import capecList from '@/components/forms/simpleLists/capecList.vue';
import techniqueList from '@/components/forms/simpleLists/techniqueList.vue';
import controlList from '@/components/forms/simpleLists/controlList.vue';
import cweList from '@/components/forms/simpleLists/cweList.vue';
import toolList from '@/components/forms/simpleLists/toolList.vue';
import tagList from '@/components/forms/simpleLists/tagList.vue';
import objectiveList from '@/components/forms/simpleLists/objectiveList.vue';
import utils from '@/utils/index';

export default {
  name: 'addPlay',
  components: {
    playList,
    capecList,
    techniqueList,
    controlList,
    cweList,
    toolList,
    tagList,
    objectiveList
  },
  data() {
    return {
      mdiCrownOutline,
      mdiCrown,
      mdiMenuRight,
      mdiLinkVariantPlus,
      mdiPlus,
      mdiMinus,
      mdiMagnify,
      formValid: false,
      newPlay: '',
      newPlayDesc: '',
      vRules: utils.validationRules,
      simpleSideList: 'playList',
      playCAPECs: [],
      playTeqs: [],
      playCtrls: [],
      playCWEs: [],
      playTools: [],
      playTags: [],
      playObjs: []
    };
  },
  computed: {
    ...mapGetters([
      'playOptions',
      'capecOptions',
      'techniqueOptions',
      'controlOptions',
      'cweOptions',
      'toolOptions',
      'tagOptions',
      'objectiveOptions'
    ])
  },
  methods: {
    ...mapActions([
      'fetchPlays',
      'fetchPlayOptions',
      'createPlay'
    ]),
    async addPlay() {
      const capecs = this.playCAPECs.map((capec) => capec.id);
      const teqs = this.playTeqs.map((teq) => teq.id);
      const ctrls = this.playCtrls.map((ctrl) => ctrl.id);
      const cwes = this.playCWEs.map((cwe) => cwe.id);
      const tools = this.playTools.map((tool) => tool.id);
      const tags = this.playTags.map((tag) => tag.id);
      const objs = this.playObjs.map((obj) => obj.id);
      try {
        await this.createPlay({
          name: this.newPlay,
          description: this.newPlayDesc,
          attackpatterns: capecs,
          techniques: teqs,
          controls: ctrls,
          cwes,
          tools,
          tags,
          objectives: objs
        });
        this.fetchPlays('?ordering=id');
        this.fetchPlayOptions();
        this.resetForm();
      } catch (err) {
        console.error(err);
      }
    },
    removeCAPEC(item) {
      this.playCAPECs = this.playCAPECs.filter((capec) => capec.id !== item.id);
    },
    removeTechnique(item) {
      this.playTeqs = this.playTeqs.filter((teq) => teq.id !== item.id);
    },
    removeControl(item) {
      this.playCtrls = this.playCtrls.filter((ctrl) => ctrl.id !== item.id);
    },
    removeCWE(item) {
      this.playCWEs = this.playCWEs.filter((cwe) => cwe.id !== item.id);
    },
    removeTool(item) {
      this.playTools = this.playTools.filter((tool) => tool.id !== item.id);
    },
    removeTag(item) {
      this.playTags = this.playTags.filter((tag) => tag.id !== item.id);
    },
    removeObj(item) {
      this.playObjs = this.playObjs.filter((obj) => obj.id !== item.id);
    },
    resetForm() {
      this.newPlay = '';
      this.newPlayDesc = '';
      this.playCAPECs = [];
      this.playTeqs = [];
      this.playCtrls = [];
      this.playCWEs = [];
      this.playTags = [];
      this.playTools = [];
      this.playObjs = [];
      this.$refs.addPlayForm.resetValidation();
    }
  }
};
</script>
